<template>
  <div>
    <div class="px-3 py-1 bg-gray-1">
      <div v-if="paymentSelected.imageUrl">
        <img
          :src="paymentSelected.imageUrl"
          :alt="paymentSelected.imageUrl"
          class="payment-image"
        />
        <b-icon
          v-if="isCanEdit"
          icon="x-circle-fill"
          class="delete-icon"
          @click="$emit('onDeleteImage')"
        ></b-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paymentSelected: {
      required: true,
      type: Object,
    },
    isCanEdit: {
      required: true,
      type: Boolean,
    },
  },
};
</script>

<style scoped>
.payment-image {
  width: 100%;
  height: 100%;
}
.bg-gray-1 {
  background-color: #e7e6e6;
  min-height: 500px;
}
.delete-icon {
  position: absolute;
  right: 20px;
  top: 10px;
  font-size: 20px;
  cursor: pointer;
}
</style>